// extracted by mini-css-extract-plugin
module.exports = {"defaultFont":"shape-title-content_defaultFont__28O1d"};